import type { ApiAddress, EnumBusinessState } from '@Model';
import { enumBusinessStateOptions, getBadgeVariantByBusinessState, getEnumBusinessStateLabel } from '@Model';
import { Badge, Column } from '@synqo/frontend-component-library';

export const addressColumns: Column<ApiAddress>[] = [
    { name: 'number', label: 'Nummer' },
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'label', label: 'Name' },
    { name: 'street', label: 'Str' },
    { name: 'house_number', label: 'Haus-Nr.' },
    { name: 'zip_code', label: 'PLZ' },
    { name: 'city', label: 'Ort' },
    {
        name: 'business_state',
        label: 'Status',
        filterVariant: 'select',
        filterOptions: enumBusinessStateOptions,
        renderCell: ({ cellData }) => (
            <Badge variant={getBadgeVariantByBusinessState(cellData as EnumBusinessState)}>
                {getEnumBusinessStateLabel(cellData as EnumBusinessState)}
            </Badge>
        ),
    },
];
